<template lang="pug">
  e-modal(
  @confirm="runOperation()"
  @close="$emit('close')"
  title="Перерасчет"
  saveBtnLabel="Выполнить"
  ref="modal"
  :autoHeight="true"
  ).operation-recalc
    slot
      e-form(
      :formValidator="formValidator"
      form-class="fix-elements-overflow-problem"
      :enable-perfect-scrollbar="false"
      )
        div.body
          div.col
            e-form-group(
            label="Тип перерасчета"
            inputType="select"
            name="type"
            :model="fields"
            :tabView="tabView"
            :required="true"
            :options="types"
            @change="fields.branch=''"
            )

            e-form-group(
            label="Параметр перерасчета"
            inputType="select"
            name="branch"
            :model="fields"
            :tabView="tabView"
            :required="true"
            :options="parameters"
            )

            e-form-group(
            label="Период"
            inputType="calendar-range"
            name="start"
            toName="end"
            :model="fields"
            :tabView="tabView"
            :required="true"
            valueFormat="yyyy-MM-dd"
            format="dd.MM.yyyy"
            type="date"
            placeholder="от дд.мм.гггг"
            toPlaceholder="до дд.мм.гггг"
            )

            e-form-group(
            name="pay_day"
            inputType="calendar"
            label="Операционный день"
            :model="fields"
            tabView="tab1"
            :required="true"
            )

            e-form-group(
            label="Значение параметра перерасчета"
            name="value"
            :model="fields"
            :tabView="tabView"
            :required="true"
            validationRule="double"
            )
</template>

<script>
  import {wasteGenerators} from "../../../api/api-endpoints"
  import FormValidator from '../../../components/form/form-validator'
  import {OPERATION_RECACL_TYPE_NORMATIVE, OPERATION_RECACL_TYPE_TARIFF, OPERATION_RECACL_TYPE_UNIT} from "../../../config/config"

  export default {
    name: 'operation-recalc',
    props: {
      model: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        tabView: '',
        fields: {
          start: '',
          end: '',
          value: '',
          type: '',
          branch: '',
          pay_day: ''
        }
      }
    },
    computed: {
      types () {
        return [
          {id: OPERATION_RECACL_TYPE_TARIFF, name: 'По тарифу'},
          {id: OPERATION_RECACL_TYPE_NORMATIVE, name: 'По нормативу'},
          {id: OPERATION_RECACL_TYPE_UNIT, name: 'По количеству расчетных единиц'}
        ]
      },
      /**
       * Параметры перерасчета
       * норматив лс - normative[0].normativ_id
       * тариф лс - normative[0].tariff_id
       * выбор расчетной единицы - normative[0].id
       * @returns {Array}
       */
      parameters () {
        const items = []
        const normative = this.model.normative || []
        normative.forEach(n => {
          let item = null
          if (this.fields.type === OPERATION_RECACL_TYPE_NORMATIVE ) {
            item = {
              id: n.normativ_id,
              name: n.category
            }
          }
          if (this.fields.type === OPERATION_RECACL_TYPE_TARIFF ) {
            if (n.tariff) {
              item = {
                id: n.tariff.id,
                name: n.tariff.name
              }
            }
          }
          if (this.fields.type === OPERATION_RECACL_TYPE_UNIT ) {
            item = {
              id: n.id,
              name: n.category
            }
          }
          if (item) {
            items.push(item)
          }
        })
        return items
      }
    },
    created() {
      this.formValidator = new FormValidator(this)
    },
    methods: {
      runOperation: async function () {
        if (!this.model.id) {
          this.$e.warningBox('Действие станет доступно после сохранеия')
          return
        }

        const {hasError} = this.formValidator.validate()
        if (hasError === true) {
          return
        }

        try {
          this.$bar.start()
          this.$refs.modal.freezeAll()
          await this.$store.dispatch('createModel', {
            url: wasteGenerators.bankBookOperationRecalc(this.model.id),
            data: this.fields
          })
          this.$e.successBox()
          this.$emit('updated')
          this.$emit('close')
        } catch (e) {
          if (e && +e.status === 422) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(e, this)
            if (notFoundedErrorFieldsText) {
              this.$e.errorBox(
                'Некорректно заполнены поля',
                {text: notFoundedErrorFieldsText}
              )
            }
          } else {
            this.$e.errorBox(e)
          }
        } finally {
          this.$refs.modal.unFreezeAll()
          this.$bar.finish()
        }
      }
    }
  }
</script>

